import { BodyText } from '@policygenius/mortar';

import Modal from 'components/Modal';

import { CONTENT, NAME, TITLE } from './constants';

const GovernmentEmployeeModal = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal(state: boolean): void;
}) => {
  const closeModal = () => setShowModal(false);

  return (
    <Modal
      title={TITLE}
      primaryCTA={{ text: 'Proceed', onClick: closeModal }}
      name={NAME}
      onRequestClose={closeModal}
      showModal={showModal}
    >
      <BodyText size="large">{CONTENT}</BodyText>
    </Modal>
  );
};

export default GovernmentEmployeeModal;
